export default __webpack_public_path__ + "static/media/wheel.af8ef5fc.jpg";